<template>
  <div class="col-12 py-1 py-md-0 pb-md-1">
    <div class="landing-content md-content">
      <div class="big-logo mb-3 ml-4">
        <img src="img/swampum-logo.png" alt="Swampum" class="logo" />
      </div>
      <div class="text-content">
        <h1 class="mb-3 lead-title">
          Give&nbsp;stuff, get&nbsp;stuff, feel&nbsp;good!
        </h1>
        <p class="lead-banner">
          Swampum® is a unique online community where you can <strong>sell</strong> or
          <strong>buy</strong>, <strong>lend</strong> or <strong>borrow</strong> — even <strong>give</strong> and
          <strong>get free</strong> stuff! — with neighbors, friends, or anyone you’d
          like.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "SLandingContent",
  props: ["landingItems"],
};
</script>

<style lang="scss">
.big-logo {
  width: 28.69em;
}
.lead-title {
  font-weight: 500;
  font-size: 38px;
  line-height: 38px;
  letter-spacing: 1.25px;
}
.lead-banner {
  font-weight: 500;
  font-size: 26px;
  line-height: 26px;
  letter-spacing: 1.25px;
  text-align: justify;
}
@media screen and (max-width: 1023px) {
  .big-logo {
    margin-top: 2em;
    max-width: 17.69em;
  }
  .lead-title {
    font-size: 21px;
  }
  .lead-banner {
    font-size: 17px;
  }
}
</style>

<style lang="scss" scoped>
.landing-content {
  border-radius: 5px;
}
.text-content {
  padding: 0 3rem;
}
.lead-banner,
.lead-title {
  color: $primary;
  padding-bottom: 1rem;
}
</style>
